<template>
  <div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button
            color="info"
            outline
            @click.prevent="$router.push({ name: 'question-create' })"
            >{{ $t('add_new') }}</ts-button
          >
          <div class="d-flex">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px;"
              class="inline-block"
            />
            <ts-button
              outline
              class="ml-2"
              v-tooltip="$t('invoice.filter')"
              @click.prevent="visible = true"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
        </div>
        <!-- drawer -->
        <a-drawer
          :title="$t('filter')"
          placement="right"
          :closable="false"
          :visible="visible"
          @close="onCloseDrawer"
          :zIndex="1020"
          width="300px"
        >
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="ts-text-xs">{{ $t('question.status') }}</label>
                <a-select
                  v-model="status"
                  style="width:100%"
                  @change="fetchData"
                >
                  <a-select-option :value="1">{{
                    $t('eschool.progressing')
                  }}</a-select-option>
                  <a-select-option :value="2">{{
                    $t('eschool.closed')
                  }}</a-select-option>
                </a-select>
              </div>
            </div>
          </div>
        </a-drawer>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :rowGroup="{
            field: 'grade.grade_name_foreign'
          }"
        >
          <template v-slot="{ record, index }">
            <td
              :style="rowStyle(record.is_active)"
              class="ts-whitespace-no-wrap"
            >
              <a
                v-tooltip="record.question_type.question_type_en"
                class="btn btn-default btn-xs"
                ><i :class="questionType(record.question_type_id)"></i
              ></a>
              {{ record.question_code }}
            </td>
            <td :style="rowStyle(record.is_active)">
              <div
                v-if="
                  record.question_name ? record.question_name.length < 70 : true
                "
                v-html="record.question_name"
              ></div>
              <div
                v-else
                v-html="record.question_name.substring(0, 70) + '...'"
                v-popover="{ name: record.question_code }"
                style="cursor: pointer"
                class="question"
              ></div>
              <popover
                :name="record.question_code"
                :width="600"
                :pointer="true"
              >
                <ckeditor
                  :editor="editor"
                  v-model="record.question_name"
                  :disabled="editorDisabled"
                ></ckeditor>
              </popover>
            </td>
            <td
              :style="rowStyle(record.is_active)"
              class="ts-whitespace-no-wrap"
            >
              {{
                record.question_catalog
                  ? record.question_catalog.question_catalog_name_en
                  : ''
              }}
            </td>
            <td
              :style="rowStyle(record.is_active)"
              class="ts-whitespace-no-wrap ts-text-center"
            >
              {{
                record.difficulty_level
                  ? record.difficulty_level.difficulty_level
                  : ''
              }}
            </td>
            <td
              :style="rowStyle(record.is_active)"
              class="ts-whitespace-no-wrap ts-text-center"
            >
              {{ record.max_score }}
            </td>
            <td
              :style="rowStyle(record.is_active)"
              class="ts-whitespace-no-wrap ts-text-center"
            >
              {{ record.penalty_rate }}
              {{ record.penalty_type }}
            </td>
            <td :style="rowStyle(record.is_active)">
              <div
                v-if="
                  record.explanation ? record.explanation.length < 50 : true
                "
                v-html="record.explanation"
              ></div>
              <div
                v-else
                v-html="record.explanation.substring(0, 50) + '...'"
                v-popover="{ name: index }"
                style="cursor: pointer"
                class="question"
              ></div>
              <popover :name="index" :width="500" :pointer="true">
                <ckeditor
                  :editor="editor"
                  v-model="record.explanation"
                  :disabled="editorDisabled"
                ></ckeditor>
              </popover>
            </td>
            <td
              :style="rowStyle(record.is_active)"
              class="text-center ts-whitespace-no-wrap"
            >
              <span :class="statusStyle(record.is_active)">{{
                activeStatus(record.is_active)
              }}</span>
            </td>
            <td
              :style="rowStyle(record.is_active)"
              class="text-center ts-whitespace-no-wrap ts-space-x-2"
            >
              <a
                href="#"
                v-tooltip="$t('question.preview')"
                class="text-info"
                @click.prevent="preview(record)"
              >
                <i class="fas fa-search-plus"></i>
              </a>
              <a
                href="#"
                v-tooltip="$t('question.duplicate')"
                class="text-warning"
                @click.prevent="duplicate(record)"
              >
                <i class="fas fa-exchange-alt"></i>
              </a>
              <a
                href="#"
                v-tooltip="$t('question.usedIn')"
                class="text-muted"
                @click.prevent="usedIn(record)"
              >
                <i class="fas fa-history"></i>
              </a>
              <a
                href="#"
                v-tooltip="$t('edit')"
                class="text-primary"
                @click.prevent="edit(record)"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a
                href="#"
                v-tooltip="$t('delete')"
                class="text-danger"
                @click.prevent="destroy(record)"
                :disabled="record._deleting"
              >
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fas fa-trash" v-else></i>
              </a>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'
import moment from 'moment'
import Popover from 'vue-js-popover'

Vue.use(Popover)

import Vue from 'vue'
import CKEditor from '@ckeditor/ckeditor5-vue2'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
Vue.use(CKEditor)

export default {
  name: 'questionStaff',
  data() {
    return {
      loading: false,
      visible: false,
      rangeDate: [moment().add(-7, 'Day'), moment()],
      editor: ClassicEditor,
      editorDisabled: true
    }
  },
  computed: {
    ...mapState('eschool/eExam/question', ['resources', 'pagination']),
    rowStyle: () => status => {
      let color = ''

      switch (status) {
        case true:
          color = ''
          break
        case false:
          color = '#c7c7c7'
          break
      }

      return {
        color: color
      }
    },
    statusStyle: () => status => {
      let badge = ''

      switch (status) {
        case true:
          badge = 'badge badge-success'
          break
        case false:
          badge = 'badge badge-default'
          break
      }

      return badge
    },
    activeStatus: () => status => {
      let value = ''

      switch (status) {
        case true:
          value = 'Publish'
          break
        case false:
          value = 'Draft'
          break
      }

      return value
    },
    search: {
      get() {
        return this.$store.state.eschool.eExam.question.search
      },
      set(newValue) {
        this.$store.commit('eschool/eExam/question/SET_SEARCH', newValue)
        this.$store.commit('eschool/eExam/question/RESET_CURRENT_PAGE')
      }
    },
    status: {
      get() {
        return this.$store.state.eschool.eExam.question.status
      },
      set(newValue) {
        this.$store.commit('eschool/eExam/question/SET_STATUS_VALUE', newValue)
      }
    },
    columns() {
      return [
        { name: this.$t('question.questionCode'), sortKey: 'question_code' },
        { name: this.$t('question.questionName'), sortKey: 'question_name' },
        {
          name: this.$t('question.questionCatalog'),
          sortKey: 'question_catalog.question_catalog_name_en'
        },
        {
          name: this.$t('question.difficultyLevel'),
          sortKey: 'difficulty_level.difficulty_level',
          style: 'text-align:center; width:7%'
        },
        {
          name: this.$t('question.maxScore'),
          style: 'text-align:center; width:7%'
        },
        {
          name: this.$t('question.penalty'),
          style: 'text-align:center; width:7%'
        },
        {
          name: this.$t('question.explanation'),
          style: 'width:20%'
        },
        { name: this.$t('status'), style: 'text-align:center; width:7%' },
        { name: this.$t('actions'), style: 'text-align:center; width:7%' }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    questionType(question_type_id) {
      if ([1, 8, 9].includes(question_type_id)) {
        return 'far fa-dot-circle'
      }
      if ([2].includes(question_type_id)) {
        return 'far fa-caret-square-down'
      }
      if ([3].includes(question_type_id)) {
        return 'far fa-check-square'
      }
      if ([4].includes(question_type_id)) {
        return 'far fa-window-minimize'
      }
      if ([5].includes(question_type_id)) {
        return 'fas fa-columns'
      }
      if ([6].includes(question_type_id)) {
        return 'fas fa-expand-arrows-alt'
      }
      if ([7].includes(question_type_id)) {
        return 'far fa-square'
      }
    },
    onCloseDrawer() {
      this.visible = false
    },
    fetchData(attributes = {}) {
      this.loading = true
      this.$store
        .dispatch('eschool/eExam/question/fetch')
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    edit(record) {
      this.$store.commit('eschool/eExam/question/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'question-edit',
        params: { id: record.question_id }
      })
    },
    closeOpen(record) {
      this.question_status_loading = true
      this.$store
        .dispatch('eschool/eExam/question/changeStatus', {
          id: record.question_id,
          data: {
            question_status_id: record.question_status_id
          }
        })
        .then(() => {
          record.status_open = record.status_open ? false : true
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.question_status_loading = false
        })
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  }
}
</script>
<style scoped>
.question:hover {
  color: #007bff;
}
</style>
